<ng-container *ngIf="loading; else loaded">
  <mat-spinner class="init-spinner" color="primary" diameter="75"></mat-spinner>
</ng-container>

<ng-template #loaded>
  <div class="modal-content-container immo-billing-detail__container">
    <div class="id-container">
      <span class="click-link" (click)="openSubProject()">
        #{{ detail.project.id }}
      </span>
    </div>

    <client-adjustment-header
      [title]="'Te plaatsen'"
      [type]="detail.expectedType.toLowerCase()"
      [currentCreatedAt]="detail.currentCreatedAt"
      [projectContacts]="detail.project.projectContacts"
      [extraCompanyContacts]="detail.project.projectExtraCompanyContacts"
      [client]="false"
      [approved]="detail.approved"
      [approvedRegistration]="detail.approvedRegistration"
      (impersonateClicked)="closeDialog()"
    ></client-adjustment-header>

    <internal-info [subProject]="detail"></internal-info>

    <ng-container *ngIf="detail.type === 'BaseProject'; else adjustmentInfo">
      <ng-container *ngIf="detail.project.products?.length > 0">
        <project-detail-card
          [cardType]="'configuration'"
          [products]="detail.project.products"
          [firstProduct]="detail.project.products[0]"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'design'"
          [products]="detail.project.products"
          [ipBoardExamples]="detail.designPictures"
        ></project-detail-card>

        <project-detail-card
          [cardType]="'placement'"
          [firstProduct]="detail.project.products[0]"
          [projectPlacement]="detail.projectPlacement"
          [baseProject]="detail"
          [project]="detail.project"
          [assets]="detail.executionPictures"
        ></project-detail-card>

        <div
          *ngFor="
            let company of involvedCompanies;
            let first = first;
            let count = count;
            trackBy: trackById
          "
          [class.mt-3]="first"
        >
          <project-detail-card
            [cardType]="'facturation'"
            [project]="detail.project"
            [baseProject]="detail"
            [company]="company"
            [alternativeTitle]="
              count > 1 && company.regularName?.length > 0
                ? company.regularName + ' preview'
                : ''
            "
            [outerTitle]="count > 1"
          ></project-detail-card>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #adjustmentInfo>
      <client-adjustment-summary
        *ngIf="baseProject != null"
        [address]="baseProject.projectPlacement.address"
        [placementFloor]="baseProject.projectPlacement.placementFloor"
        [executionAssets]="latestExecutionAssets"
        [secondBoard]="baseProject.projectPlacement.secondBoard"
        [otherOrderPlacementInfo]="
          baseProject.projectPlacement.otherOrderPlacementInfo
        "
        [products]="detail.project.products"
        [originalProjectId]="detail.project.id"
        [adjustment]="detail"
      ></client-adjustment-summary>

      <div class="executed-container">
        <div class="executed__data-container">
          <client-adjustment-form
            [type]="detail.expectedType.toLowerCase()"
            [readOnly]="false"
            [adjustment]="detail"
            [isExecuted]="true"
            [products]="detail.project.products"
            [address]="baseProject.projectPlacement.address"
            [placementFloor]="baseProject.projectPlacement.placementFloor"
            [projectId]="detail.project.id"
            [projectContacts]="detail.project.projectContacts"
            [offlineUpload]="false"
            [minDate]="minDate"
          ></client-adjustment-form>
        </div>

        <div
          *ngIf="detail.designPictures?.length > 0"
          class="executed__image-container"
        >
          <img
            *ngIf="isImage(detail.designPictures[0])"
            class="max-summary-width max-summary-height clickable"
            src="/api/assets/{{ detail.designPictures[0].uuid }}"
            (click)="openDesignLightbox()"
          />
        </div>
      </div>

      <client-adjustment-invoice-info
        [adjustment]="detail"
        [baseProject]="baseProject"
        [project]="detail.project"
      ></client-adjustment-invoice-info>
    </ng-template>

    <divergent-price-collapse
      [subProject]="detail"
      [baseProject]="detail.type === 'BaseProject' ? detail : baseProject"
      [project]="detail.project"
      [collaborative]="detail.project.collaborative"
      [showSave]="true"
      [savingLines]="savingLines"
      (save)="savePriceUpdate($event)"
      (saveLines)="savePriceUpdateLines()"
    ></divergent-price-collapse>

    <div class="immo-ip-placer-completion__container">
      <div class="admin-section-header" [class.collapsed]="executionCollapsed">
        <div
          [class.collapsed]="executionCollapsed"
          class="d-flex"
          (click)="executionCollapsed = !executionCollapsed"
        >
          <div class="d-flex">
            <span>
              {{ executionHeader }}
              <b *ngIf="notExecutedHistoryItem == null" class="ml-2">
                ({{
                  placerDisplay != null
                    ? placerDisplay
                    : 'datum -
                Installateur'
                }})
              </b>
            </span>

            <div
              *ngIf="!client && placer != null"
              class="clickable impersonate-icon"
              [class.disabled]="placer?.user?.id == null"
              [matTooltip]="
                placer?.user?.id != null
                  ? 'Nabootsen'
                  : 'Nabootsen niet mogelijk, geen gebruiker gevonden'
              "
              (click)="$event.stopPropagation(); impersonateUser(placer?.user)"
            >
              <mat-icon>group</mat-icon>
            </div>
          </div>

          <div class="admin-section-arrow">
            <div *ngIf="!client">
              <button mat-icon-button>
                <mat-icon class="admin-section-arrow-icon">
                  arrow_drop_up
                </mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div [collapse]="executionCollapsed" [isAnimated]="!safari">
        <div class="collapse-content-container execution-collapse-content">
          <ng-container
            *ngIf="notExecutedHistoryItem == null; else showNotExecuted"
          >
            <immo-ip-placer-project-completion
              [subProject]="detail"
              [baseProject]="baseProject"
            ></immo-ip-placer-project-completion>
          </ng-container>

          <ng-template #showNotExecuted>
            <display-not-executed-history-item
              [notExecutedHistoryItem]="notExecutedHistoryItem"
              [displayOnly]="true"
              [useMatCard]="true"
            ></display-not-executed-history-item>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="ready-log-container">
      <mat-checkbox
        [ngModel]="
          detail.billingReady != null && detail.billingReady.date != null
        "
        (ngModelChange)="onCheckBillingReady($event)"
        [disabled]="billingReadyLoading"
      >
        Klaar voor facturatie
      </mat-checkbox>

      <span
        *ngIf="detail.billingReady != null && detail.billingReady.date != null"
      >
        {{
          detail.billingReady.date
            | date : 'dd/MM/yyyy HH:mm' : 'Europe/Brussels' : 'nl-BE'
        }}
        - {{ detail.billingReady.byFirstName }}
        {{ detail.billingReady.byLastName }}
      </span>
    </div>
  </div>
</ng-template>
